export default __webpack_public_path__ + "static/media/Sasha_9781408358641.d08ea48a.jpg";